export default "__VITE_ASSET__BXR8aJgh__"